import { Component, ContentChild, Input, ViewChild, TemplateRef, ElementRef, OnInit, AfterViewInit, NgZone, Renderer2 } from '@angular/core';

import { LayoutStore } from '../layout.store';

import { HeaderService } from './header.service';
/**
 * Header Logo
 */
export class HeaderLogoComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-header-logo',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function HeaderLogoComponent_tsickle_Closure_declarations() {
/** @type {?} */
HeaderLogoComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderLogoComponent.ctorParameters;
/** @type {?} */
HeaderLogoComponent.propDecorators;
/** @type {?} */
HeaderLogoComponent.prototype.templateRef;
}

/**
 * Header Logo Mini
 */
export class HeaderLogoMiniComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-header-logo-mini',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function HeaderLogoMiniComponent_tsickle_Closure_declarations() {
/** @type {?} */
HeaderLogoMiniComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderLogoMiniComponent.ctorParameters;
/** @type {?} */
HeaderLogoMiniComponent.propDecorators;
/** @type {?} */
HeaderLogoMiniComponent.prototype.templateRef;
}

/**
 * Header
 */
export class HeaderComponent implements OnInit, AfterViewInit {
private isSidebarLeftCollapsed: boolean;
private isSidebarRightCollapsed: boolean;

   isSidebarLeftToggle = true;
   isSidebarRightToggle = true;
public headerLogoComponent: HeaderLogoComponent;
public headerLogoMiniComponent: HeaderLogoMiniComponent;
private headerElement: ElementRef;
private sidebarLeftToggleElement: ElementRef;
private sidebarRightToggleElement: ElementRef;
/**
 * \@method constructor
 * @param {?} layoutStore
 * @param {?} ngZone
 * @param {?} renderer2
 * @param {?} elementRef
 * @param {?} headerService
 */
constructor(
private layoutStore: LayoutStore,
private ngZone: NgZone,
private renderer2: Renderer2,
private elementRef: ElementRef,
private headerService: HeaderService
  ) {}
/**
 * @return {?}
 */
ngOnInit() {

  }
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    this.headerService.elementRef = this.headerElement;
    
    if(this.sidebarLeftToggleElement) {
      this.layoutStore.isSidebarLeftCollapsed.subscribe((value: boolean) => {
        this.isSidebarLeftCollapsed = value;
      });
      this.ngZone.runOutsideAngular(() => {
        this.renderer2.listen(this.sidebarLeftToggleElement.nativeElement, 'click', (event: Event) => {
          event.preventDefault();
          this.layoutStore.sidebarLeftCollapsed(!this.isSidebarLeftCollapsed);
        });
      });
    }
    if(this.sidebarRightToggleElement) {
      this.layoutStore.isSidebarRightCollapsed.subscribe((value: boolean) => {
        this.isSidebarRightCollapsed = value;
      });
      this.ngZone.runOutsideAngular(() => {
        this.renderer2.listen(this.sidebarRightToggleElement.nativeElement, 'click', (event: Event) => {
          event.preventDefault();
          this.layoutStore.sidebarRightCollapsed(!this.isSidebarRightCollapsed);
        });
      });
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-header',
  template: `
    <header #headerElement class="main-header">
      <a href="/" class="logo">
        <span class="logo-mini"><ng-template [ngTemplateOutlet]="headerLogoMiniComponent?.templateRef"></ng-template></span>
        <span class="logo-lg"><ng-template [ngTemplateOutlet]="headerLogoComponent?.templateRef"></ng-template></span>
      </a>
      <nav *ngIf="isSidebarLeftToggle" class="navbar navbar-static-top">
        <a #sidebarLeftToggleElement href="#" class="sidebar-toggle">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </a>
        <div *ngIf="isSidebarRightToggle" class="sidebar-right-toggle">
          <a #sidebarRightToggleElement href="#"><i class="fa fa-gears"></i></a>
        </div>
        <ng-content></ng-content>
      </nav>
    </header>
  `,
  styles: [`
    :host {
      display: block;
    }

    .sidebar-right-toggle {
      float: right;
    }

    .sidebar-right-toggle a {
      padding: 15px;
      display: block;
      line-height: 20px;
      cursor: pointer;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LayoutStore, },
{type: NgZone, },
{type: Renderer2, },
{type: ElementRef, },
{type: HeaderService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isSidebarLeftToggle': [{ type: Input },],
'isSidebarRightToggle': [{ type: Input },],
'headerLogoComponent': [{ type: ContentChild, args: [HeaderLogoComponent, ] },],
'headerLogoMiniComponent': [{ type: ContentChild, args: [HeaderLogoMiniComponent, ] },],
'headerElement': [{ type: ViewChild, args: ['headerElement', ] },],
'sidebarLeftToggleElement': [{ type: ViewChild, args: ['sidebarLeftToggleElement', ] },],
'sidebarRightToggleElement': [{ type: ViewChild, args: ['sidebarRightToggleElement', ] },],
};
}

function HeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
HeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderComponent.ctorParameters;
/** @type {?} */
HeaderComponent.propDecorators;
/** @type {?} */
HeaderComponent.prototype.isSidebarLeftCollapsed;
/** @type {?} */
HeaderComponent.prototype.isSidebarRightCollapsed;
/** @type {?} */
HeaderComponent.prototype.isSidebarLeftToggle;
/** @type {?} */
HeaderComponent.prototype.isSidebarRightToggle;
/** @type {?} */
HeaderComponent.prototype.headerLogoComponent;
/** @type {?} */
HeaderComponent.prototype.headerLogoMiniComponent;
/** @type {?} */
HeaderComponent.prototype.headerElement;
/** @type {?} */
HeaderComponent.prototype.sidebarLeftToggleElement;
/** @type {?} */
HeaderComponent.prototype.sidebarRightToggleElement;
/** @type {?} */
HeaderComponent.prototype.layoutStore;
/** @type {?} */
HeaderComponent.prototype.ngZone;
/** @type {?} */
HeaderComponent.prototype.renderer2;
/** @type {?} */
HeaderComponent.prototype.elementRef;
/** @type {?} */
HeaderComponent.prototype.headerService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
